export default "__VITE_ASSET__pik0AYmC__"